import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
function Blogcard() {
    const Blogs = [
        {
            id: 1,
            title:"Cloud Computing 101:What Every Business Needs to Know",
            category: "Resources",
            imageUrl: "https://csnainc.com/wp-content/uploads/2023/07/cloud-computing-thumbnail-1200x675.png",
            link: "/blog",
            date: "Mar 25, 2024",
            readTime: "4 min read",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
            categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6843ac20aec_icon-1-blog-categories-dark-template.svg"
        },
        {
            id: 2,
            title: "Stealth VPNs: Elevating Online Security",
            category: "Resources",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65f304dff15985fa660f967b_Blog%20mini%20thumbnail.jpg",
            link: "/blog",
            date: "Mar 14, 2024",
            readTime: "3 min read",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
                        categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6843ac20aec_icon-1-blog-categories-dark-template.svg"
        },
        {
            id: 3,
            title: "Setting Up a VPN for Your Business:A Step-by-Step Guide",
            category: "Guides",
            imageUrl: "https://www.trio.so/blog/wp-content/uploads/2024/03/How-to-Setup-a-VPN-for-Small-Businesses.webp",
            link: "/blog",
            date: "Feb 21, 2024",
            readTime: "3 min read",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
            categoryIcon:'https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6f8d4c20af1_icon-2-blog-categories-dark-template.svg'
        },
        {
            id: 4,
            title: "AI in Business Transformation: A Thoughtful Dialogue",
            category: "Resources",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65ce2bc11e75a6e9182d4691_Newsletter%20thumbnail.jpg",
            link: "/blog",
            date: "Feb 15, 2024",
            readTime: "4 min read",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } },           
             categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6843ac20aec_icon-1-blog-categories-dark-template.svg"
        },
        {
            id: 5,
            title: "Blockchain Basics for Business Leaders",
            category: "Resources",
            imageUrl: "https://media.licdn.com/dms/image/D4D12AQHzdmOt7X2tXA/article-cover_image-shrink_600_2000/0/1682926614995?e=2147483647&v=beta&t=0gsto43jUZzBMgSZuq_A0s6f1ntUvsazwyzSWgi9c_c",
            link: "/blog",
            date: "Jan 27, 2024",
            readTime: "2 min read",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
                        categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6843ac20aec_icon-1-blog-categories-dark-template.svg"
        },
        {
            id: 6,
            title: "Unveiling AI: A Transformation in Business",
            category: "Resources",
            imageUrl:'https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/65aaa1aaf689d3140a05afee_NetAesthetics%20Blog%20-%20AI%20Transformation%20in%20Business.webp',
            link: "/blog",
            date: "Jan 20, 2024",
            readTime: "2 min read",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } },
                        categoryIcon: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/61962f94f13cb6843ac20aec_icon-1-blog-categories-dark-template.svg"
        }
    ];
    
    
  return (
  <>
    
    <div className='blog_section wow animate__fadeInUp' data-wow-duration="1s">
        {Blogs.map(Blog => (
            <Card className='muicard' key={Blog.id}>
                <Box
                    sx={{
                        position: 'relative',
                        height: 265,
                        backgroundImage: `url(${Blog.imageUrl})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <Box className="categorytext d-flex" sx={Blog.customStyle}>
                        {Blog.categoryIcon && (
                            <img src={Blog.categoryIcon} alt={`${Blog.category} icon`} style={{ marginRight: '8px' }} />
                        )}
                        {Blog.category}
                    </Box>
                </Box>
                <CardContent style={{textAlign:'left'}}>
                    <a  href={`/blog/${Blog.id}`} className='typographytext' variant="body2">
                        {Blog.title}
                    </a>
                </CardContent>
                <CardActions sx={{
                    flexDirection: 'column',
                    textAlign: 'left',
                    alignItems: 'flex-start',
                }}>
                    {/* New content before the Read More button */}
                    <div className="card-post-item-about-wrapper">
                        <div className="card-post-item-about-content">
                            <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb66281c20a45_icon-1-post-about-dark-template.svg" loading="lazy" alt="" className="image card-post-item-about-icon" />
                            <div>{Blog.date}</div>
                        </div>
                        <div className="card-post-item-about-content">
                            <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb67710c20a43_icon-2-post-about-dark-template.svg" loading="lazy" alt="" className="image card-post-item-about-icon" />
                            <div className="w-embed">{Blog.readTime}</div>
                        </div>
                    </div>
                    {/* Read More button */}
                    <a  href={`/blog/${Blog.id}`} className='muireadmore'>Read More <span className="arrow_icon"> ↗</span></a>
                    <div className='underline_animation'></div>
                </CardActions>
            </Card>
        ))}
    </div>
   </>
  )
}

export default Blogcard